import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFormHexagon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="form-hexagon"><path d="M10.123 2.46628C11.2832 1.79656 12.7129 1.79656 13.873 2.46628L19.3164 5.60886C20.4765 6.27866 21.1912 7.51733 21.1914 8.85691V15.1421C21.1914 16.4817 20.4765 17.7202 19.3164 18.3901L13.873 21.5327C12.7128 22.2026 11.2833 22.2026 10.123 21.5327L4.67969 18.3901C3.51955 17.7202 2.80469 16.4817 2.80469 15.1421V8.85691C2.80485 7.51733 3.51956 6.27866 4.67969 5.60886L10.123 2.46628Z" fill="currentColor"/></CentralIconBase>;
};

export default IconFormHexagon;
